import { onMounted, onUnmounted } from 'vue';

/**
 * @typedef {Object} KeyPressOptions
 * @property {string|string[]} key - Key(s) to listen for (e.g., 'Escape', 'k', ['a', 'b'])
 * @property {Function} handler - Callback function when key is pressed
 * @property {boolean} [ctrlKey=false] - Require Ctrl key to be pressed
 * @property {boolean} [metaKey=false] - Require Meta key (Command on Mac) to be pressed
 * @property {boolean} [preventDefault=true] - Prevent default browser behavior
 */

/**
 * Composable for handling keyboard events
 * @param {KeyPressOptions} options - Configuration options
 */
export function useKeyPress(options) {
  const { key, handler, ctrlKey = false, metaKey = false, preventDefault = true } = options;

  const keys = Array.isArray(key) ? key.map((k) => k.toLowerCase()) : [key.toLowerCase()];

  const handleKeyDown = (event) => {
    const pressedKey = event.key.toLowerCase();

    if (!keys.includes(pressedKey)) return;

    const modifierRequired = ctrlKey || metaKey;
    const modifierPressed = event.ctrlKey || event.metaKey;
    if (modifierRequired && !modifierPressed) return;

    if (preventDefault) {
      event.preventDefault();
    }

    handler(event);
  };

  onMounted(() => {
    document.addEventListener('keydown', handleKeyDown);
  });

  onUnmounted(() => {
    document.removeEventListener('keydown', handleKeyDown);
  });
}
